<template>
  <div class="login-container">
    <div class="loginInner">
      <div class="login-bg">
        <h4 class="info">您好</h4>
        <h5>{{ nowDate }}</h5>
      </div>
      <el-form
        autocomplete="on"
        class="login-form"
        label-position="left"
        ref="loginForm"
        v-loading="loading"
      >
        <div class="title-container">
          <h3 class="title">竞赛材料提交系统</h3>
        </div>

        <el-form-item label="手机号" prop="username" style="margin-top: 40px;">
          <el-input
            @input="trimPhone"
            autocomplete="on"
            placeholder="输入手机号"
            prefix-icon="el-icon-mobile-phone"
            tabindex="1"
            v-model="phone"
          />
        </el-form-item>

        <el-tooltip content="Caps lock is On" manual placement="right" v-model="capsTooltip">
          <el-form-item label="验证码" prop="vaicode" style="display: flex; flex-direction: column;">
            <div style="display:flex; align-items: center;">
              <el-input
                autocomplete="on"
                class="vaiCodeinput"
                key="text"
                name="vaicode"
                placeholder="验证码"
                prefix-icon="el-icon-menu"
                tabindex="3"
                v-model="code"
              />
              <div class="vaiCode">
                <el-button
                  @click="getCode(num)"
                  class="primary"
                  plain
                  round
                  style="margin-left: 30px;letter-spacing: 2px;"
                  type="primary"
                  v-preventRepeatClick
                >{{ num || "获取验证码" }}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-tooltip>
        <div class="button_wrap">
          <div @click="handleLogin" class="login-btn" v-preventRepeatClick>登录</div>
        </div>
      </el-form>
    </div>
    <div class="login-title" v-if="activietitle">{{activietitle}}</div>
    <div class="bottom">
      <div class="login-info">
        <div class="desc">
          1.请参赛选手使用报名时填写的手机号进行登录，如遗忘请联系赛事组织者或领队人员询问
          <br />2.请各参赛选手在规定时间内，通过本系统提交竞赛材料，材料一经提交，组委会不接受
          任何形式的更改或调换，逾期未报送者，视作放弃参赛资格
          <br />
          <div class="browser">
            3.推荐使用
            <a href="https://www.google.cn/chrome/" target="_blank">Google 浏览器、</a>
            <a href="http://browser.360.cn/" target="_blank">360浏览器（极速模式）、</a>
            <a
              href="https://dlie.sogoucdn.com/se/sogou_explorer_11.0.1_0218.exe"
              target="_blank"
            >搜狗浏览器、</a>
            <a
              href="https://www.microsoft.com/zh-cn/edge?icid=SSM_AS_Promo_Other_Edge"
              target="_blank"
            >Edge浏览器</a>
            等主流浏览器访问
          </div>
        </div>
        <div class="copyright_wrap">
          <p class="copy-icp">
            &copy; {{getYear}}立智博学:
            <a href="https://beian.miit.gov.cn" target="_blank">京ICP备19019603号-2</a>
          </p>
          <!-- <p>客服电话：111111</p> -->
        </div>
      </div>
    </div>
    <!-- 地址错误弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="errorDialogVisible"
      center
      v-if="errorDialogVisible"
      width="35%"
    >
      <error-view :buttonTitle="errorButtonTitle" :text="errorMessage" @confirm="confirm" />
    </el-dialog>
  </div>
</template>

<script>
// 导入请求服务
import { sendCode, loginHander, getActivityInfo, loginReflectionHander, sendCodeReflection } from '@/service/login.js'
import { playerShouldEnterTeachingRefelction } from '@/service/teaching'
import { getCourseWareDetails } from '@/service/contestantInfo'
import ErrorView from '@/components/ErrorAlertView'
// 获取日期
function getNowdate (_this) {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let day = date.getDate()
  day = day > 9 ? day : '0' + day
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let mint = date.getMinutes()
  mint = mint > 9 ? mint : '0' + mint
  _this.nowDate = year + '年' + month + '月' + day + '日  ' + hour + ':' + mint
}
// 登陆函数
export default {
  components: {
    ErrorView
  },
  data () {
    return {
      capsTooltip: false,
      loading: false,
      code: '',
      nowDate: '',
      change_password: true,
      radio: '1',
      phone: '',
      password: '',
      phoneReg: /^1(3|4|5|6|7|8|9)\d{9}$/,
      loginForm: {
        username: '',
        password: '',
        vaicode: ''
      },
      num: false,
      activietitle: '',
      activityId: '',
      auditStatus: 'approved',
      uploadRefection: false,
      errorDialogVisible: false,
      errorMessage: '',
      errorButtonTitle: ''
    }
  },
  computed: {
    getYear () {
      let date = new Date()
      return date.getFullYear() || 2024
    }
  },
  created () {
    this.initTitle()
    setInterval(() => {
      getNowdate(this)
    }, 1000)
    this.activityId = this.getQueryString().id
    if (!this.activityId) {
      this.errorMessage = '非常抱歉，登录页参数丢失，点击关闭按钮将会关闭此页面，如有疑问请咨询系统管理员'
      this.errorButtonTitle = '关闭'
      this.errorDialogVisible = true
    } else {
      getActivityInfo(this.activityId).then(res => {
        if (res.data && res.data.title) {
          this.activietitle = res.data.title
          const hasSummaries = res.data.modules.filter(item => item.category === 'summaries').length > 0
          this.configureUploadRefection(hasSummaries)
        }
      })
    }
  },
  methods: {
    getQueryString () {
      return {
        id: this.$route.params.id,
        isRefection: this.$route.params.isReflection
      }
    },
    configureUploadRefection (hasSummaries) {
      if (!hasSummaries) {
        // 没有教学反思
        if (this.getQueryString().isRefection) {
          this.errorMessage = '非常抱歉，登录页参数错误，请点击返回按钮，将会回到活动访问平台，您可以重新选择有效上传材料入口，如有疑问请咨询系统管理员'
          this.errorButtonTitle = '返回'
          this.errorDialogVisible = true
          return
        }
      }
      if (this.getQueryString().isRefection) {
        this.uploadRefection = true
      } else {
        this.uploadRefection = false
      }
      localStorage.setItem('activity_id', this.getQueryString().id)
      sessionStorage.setItem('searchParams', this.$route.fullPath)
    },
    enterTeachingRefelctionHandler (res, sceneTime) {
      let enterStatus = false
      if (!res.drawn_contest || !res.drawn_contest.start_time) {
        enterStatus = false
      } else {
        let endDate = res.drawn_contest.start_time
        const currentTimes = new Date().getTime()
        let scheneTimes = sceneTime !== 0 ? sceneTime : 20 * 60 * 1000
        let endSceneTimes = new Date(endDate.replace(/-/g, '/')).getTime()
        if (endSceneTimes) {
          endSceneTimes += scheneTimes
        }
        // 教学反思开始时间
        sessionStorage.setItem('teachingStartTime', endSceneTimes / 1000)
        if (currentTimes >= endSceneTimes) {
          enterStatus = true
        } else {
          enterStatus = false
        }
      }
      if (res.contest_status === 'overed' || enterStatus) {
        return true
      } else {
        return false
      }
    },
    // 初始化展示TITle
    initTitle () {
      const id = this.$route.query.activity_id
      if (!id) {
        return
      }
      getActivityInfo(id).then(res => {
        if (res.data && res.data.title) {
          this.activietitle = res.data.title
        }
      })
    },
    getCode (time) {
      if (this.phone === '' || !this.phoneReg.test(this.phone)) {
        this.$confirm('请输入正确手机号', '友情提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return
      }
      if (time && time !== '重新获取验证码') { return }
      if (this.uploadRefection) {
        sendCodeReflection({ phone: this.phone }).then((res) => {
          if (res.status === 'success') {
            this.$confirm('验证码已发送至您的手机，请注意查收', '友情提示')
            if (res.data) { this.code = res.data }
            let num = 60
            let inter = setInterval(() => {
              num--
              this.num = num + '秒后重试'
              if (num === 0) {
                this.num = '重新获取验证码'
                clearInterval(inter)
              }
            }, 1000)
          } else if (res.status === 'error') {
            this.$confirm(res.msg, '友情提示')
          }
        })
      } else {
        sendCode({ phone: this.phone }).then((res) => {
          if (res.status === 'success') {
            this.$confirm('验证码已发送至您的手机，请注意查收', '友情提示')
            if (res.data) { this.code = res.data }
            let num = 60
            let inter = setInterval(() => {
              num--
              this.num = num + '秒后重试'
              if (num === 0) {
                this.num = '重新获取验证码'
                clearInterval(inter)
              }
            }, 1000)
          } else if (res.status === 'error') {
            this.$confirm(res.msg, '友情提示')
          }
        })
      }
    },
    trimPhone () {
      this.phone = this.phone.trim()
    },
    change (e) {
      e === '1' ? this.change_password = true : this.change_password = false
    },
    loginSussessCallBackHandler (res) {
      if (res.status !== 'success') {
        this.$confirm(res.msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return
      }
      localStorage.setItem('auth_token', res.data['Authentication-token'])
      localStorage.setItem('PersonInfo', JSON.stringify(res.data))
      const userInfo = res.data.user
      let activityId = res.data.activity.id
      let playerId = res.data.user.id
      let shceneTimes = 0
      res.data.activity.modules.forEach(item => {
        if (item && item.module === 'scene_sequence') {
          if (item.properties && item.properties.scene_duration) {
            shceneTimes = item.properties.scene_duration * 60 * 1000
          }
        }
      })
      if (userInfo.audit_status === this.auditStatus) {
        // 如果均线上 审核结束以后就到result
        if (!this.isDireactToOnline(res.data)) {
          this.$router.push('/Result')
          return
        }
        // 材料审核通过
        // 是否抽取课件
        getCourseWareDetails(userInfo.activity_id, userInfo.id).then(resp => {
          if (resp.data && resp.data.id) {
            if (this.isDireactToTeaching(res.data)) {
              // 是否已上传教学反思
              if (res.data.user && res.data.user.contest_summary && res.data.user.contest_summary.url) {
                this.$router.push('/Result')
              } else {
                playerShouldEnterTeachingRefelction(playerId, activityId).then(res => {
                  if (!res || !res.data) {
                    this.$router.push(`/${activityId}/${playerId}/CourseWareDetail`)
                    return
                  }
                  if (this.enterTeachingRefelctionHandler(res.data, shceneTimes)) {
                    this.$router.push(`/${activityId}/${playerId}/teachingReflection`)
                  } else {
                    // this.$router.push('/Result')
                    this.$router.push(`/${activityId}/${playerId}/CourseWareDetail`)
                  }
                })
              }
            } else {
              this.$router.push(`/${activityId}/${playerId}/CourseWareDetail`)
            }
          } else {
            this.$router.push('/DownloadAll')
          }
        })
      } else {
        // 材料审核没有通过 || 未上传材料
        this.$router.push('/PersonInfo')
      }
    },
    handleLogin () {
      if (this.uploadRefection) {
        loginReflectionHander({ phone: this.phone, code: this.code.toString(), activity_id: Number(localStorage.getItem('activity_id')) }).then((res) => {
          this.loginSussessCallBackHandler(res)
        })
      } else {
        loginHander({ phone: this.phone, code: this.code.toString(), activity_id: Number(localStorage.getItem('activity_id')) }).then((res) => {
          this.loginSussessCallBackHandler(res)
        })
      }
    },
    isDireactToTeaching (info) {
      const activity = info.activity
      if (!activity || !activity.modules || activity.modules.length === 0) {
        return false
      } else {
        let status = false
        activity.modules.forEach(item => {
          if (item.module === 'contest_summary' && item.is_selected) {
            status = true
          }
        })
        return status
      }
    },
    isDireactToOnline (info) {
      const activity = info.activity
      if (!activity || !activity.modules || activity.modules.length === 0) {
        return false
      } else {
        let status = false
        activity.modules.forEach(item => {
          if (item.module === 'scene_sequence' && item.is_selected) {
            status = true
          }
        })
        return status
      }
    },
    confirm () {
      this.errorDialogVisible = false
      if (this.errorButtonTitle === '返回') {
        window.location.href = process.env.HOME_PAGE_HOST + `?activity_id=${this.activityId}`
      } else {
        window.opener = null
        window.open('', '_self')
        window.close()
        window.location.href = document.referrer
        window.history.back(-1)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.login-container {
  height: 100%;
  width: 100%;
  background-size: cover;
  color: #fff;
  overflow: hidden;
  position: relative;
}
.login-container::before {
  content: '';
  background-size: 100%;
  position: absolute;
  top: -2%;
  left: -2%;
  width: 104%;
  height: 104%;
  filter: blur(4px);
  background: url('../../assets/images/contestant-bg.jpg') center center
    no-repeat;
  background-size: cover;
}
.loginInner {
  width: 60vw;
  height: 57.9vh;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.3);
}
.login-bg {
  width: 22vw;
  height: 100%;
  background: url('../../assets/images/contestant-front.jpg') center center;
  background-size: cover;
  padding: 2.7vh;
  box-sizing: border-box;
  text-align: left;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.title-container {
  margin: 5.3vh 0 6.4vh 0;
}
.login-form {
  /* float: right; */
  text-align: center;
  flex: 1;
  height: 100%;
  /* padding: 0px 135px 0px; */
  padding: 0 7vw;
  box-sizing: border-box;
  background-color: #fff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.button_wrap {
  padding: 0 1vw;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 11.2vh;
}
.login-btn {
  width: 18vw;
  height: 5vh;
  line-height: 5vh;
  background: rgba(193, 43, 32, 1);
  box-shadow: 0px 0px 12px 0px rgba(135, 82, 82, 0.5);
  border-radius: 2.8vh;
  cursor: pointer;
}
/* .btn-primary {
  background: #77ace4;
  width: 100%;
  margin-bottom: 30px;
}
.btn-primary:hover {
  background: #77ace4;
} */
.vaiCode {
  height: 100%;
  width: 50%;
  float: right;
  color: #333;
  letter-spacing: 0.5vw;
  font-size: 0.93vw;
  font-weight: 1vw;
  cursor: pointer;
}

.title {
  font-size: 1.5vw;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(82, 97, 109, 1);
  margin: 0;
  margin: 5.3vh 0 6.4vh 0;
}
.vaiCodeinput {
  width: 40%;
  float: left;
}
/* .login-btn {
  text-align: center;
  background-image: url("../assets/images/login-btn-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  height: 60px;
  font-weight: 18px;
  line-height: 60px;
  cursor: pointer;
  margin-top: 40px;
} */
.el-form-item {
  /* margin-bottom: 20px; */
  margin-bottom: 1.8vh;
}
.el-form-item >>> .el-form-item__label {
  height: 2.2vh;
  line-height: 2.2vh;
  margin-bottom: 1vh;
}
.info {
  font-size: 5.9vh;
  font-weight: 500;
  margin: 0;
  margin-bottom: 0.9vh;
  color: rgba(249, 249, 249, 1);
  line-height: 11.8vh;
}
.login-bg h5 {
  font-size: 1.6vh;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(249, 249, 249, 1);
  line-height: 2.3vh;
  margin: 0;
}
/* .copy-icp {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
  color: #fff;
} */
/* .copy-icp a {
  text-decoration: none;
  color: #fff;
} */
.login-title {
  text-align: center;
  width: 100%;
  font-size: 4.6vh;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(233, 233, 233, 1);
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  /* text-shadow: 1px 2px 1px rgba(249, 249, 249, 0.4); */
}
.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 1vh 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-info {
  /* width: 1152px; */
  width: 60vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.login-info .desc {
  margin-bottom: 1vh;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 1.6em;
  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
  }
}
.copyright_wrap {
  width: 100%;
  margin-top: 1.1vh;
  display: flex;
  justify-content: center;
}
.copyright_wrap p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  /* font-size: 18px; */
  font-size: 1.6vh;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  font-weight: 400;
}
.copyright_wrap p:first-of-type {
  margin-right: 2vw;
}
.copy-icp {
  font-size: 14px;
  a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue